import { render, staticRenderFns } from "./orderManagement.vue?vue&type=template&id=3bf1f5f3&scoped=true"
import script from "./orderManagement.vue?vue&type=script&lang=ts"
export * from "./orderManagement.vue?vue&type=script&lang=ts"
import style0 from "./orderManagement.vue?vue&type=style&index=0&id=3bf1f5f3&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3bf1f5f3",
  null
  
)

export default component.exports